import {Box, Skeleton} from "@mui/material";
import React from "react";

export default function DailyReportSkeleton(){
    return (
        <table className='table met-table table-bordered'>
            <thead>
            <tr>
                <th style={{width: '147px'}}><CellSkeleton/></th>
                <th style={{width: '55px'}}><CellSkeleton/></th>
                <th style={{width: '102px'}}><CellSkeleton/></th>
                <th style={{width: '102px'}}><CellSkeleton/></th>
                <th style={{width: '100px'}}><CellSkeleton/></th>
                <th style={{width: '102px'}}><CellSkeleton/></th>
                <th style={{width: '113px'}}><CellSkeleton/></th>
                <th style={{width: '113px'}}><CellSkeleton/></th>
                <th style={{width: '101px'}}><CellSkeleton/></th>
                <th style={{width: '206px'}}><CellSkeleton/></th>
                <th style={{width: '109px'}}><CellSkeleton/></th>
                <th style={{width: '109px'}}><CellSkeleton/></th>
                <th style={{width: '109px'}}><CellSkeleton/></th>
                <th style={{width: '109px'}}><CellSkeleton/></th>
            </tr>
            </thead>
            <tbody>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            </tbody>
        </table>
    )
}
export const CellSkeleton = () => <Box><Skeleton animation="wave"/></Box>
const RowSkeleton = () => <tr>
    <td><CellSkeleton/></td>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
    <th><CellSkeleton/></th>
</tr>
export const TableBodyRowsSkeleton=()=>{
    return (
        <>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
            <RowSkeleton/>
        </>
    )
}
